import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export type RewardsOffers = Static<typeof RewardsOffersSchema>;
export const RewardsOffersSchema = Type.Array(
  Type.Object({
    id: Type.String(),
    type: Type.String(),
    amount: Type.String(),
    currencyCode: Type.String(),
  })
);
